import { useMasterData } from "./api/useMasterData";

export const useStaffMeta = () => {

    const {
        roles: rolesData,
        isErrorRoles,
        isLoadingRoles,
        status: statusData,
        isErrorStatus,
        isLoadingStatus,
    } = useMasterData()

    const roles = rolesData.filter(role => role.role?.toLowerCase() !== "user");
    const status = statusData.filter(stat => stat?.category?.toLowerCase() === "user");

    const roleOptions = roles.map(item => ({
        roleId: item.roleId,
        role: item.role
    }));

    const statusOptions = status.map(item => ({
        statusId: item.statusId,
        status: item.status
    }));

    return {
        roles,
        status,
        isLoading: isLoadingRoles || isLoadingStatus,
        isError: isErrorRoles || isErrorStatus,
        isLoadingStatus: isLoadingStatus,
        isLoadingRoles: isLoadingRoles,
        isErrorRoles,
        isErrorStatus,
        roleOptions,
        statusOptions
    };
};